var events = {
  LOCATOR: {
    FOCUS: 'LOCATOR.FOCUS',
  },
  DEALERS: {
    DATA_LOADED: 'DEALERS.DATA_LOADED',
    SEARCH: 'DEALERS.SEARCH',
    UPDATE_ZIPCODE: 'DEALERS.UPDATE_ZIPCODE',
    SET_PREFERRED: 'DEALERS.SET_PREFERRED',
    UNSET_PREFERRED: 'DEALERS.UNSET_PREFERRED',
    LIST_UPDATED: 'DEALERS.LIST_UPDATED',
    SELECT: 'DEALERS.SELECT',
    OPEN_DETAIL: 'DEALERS.OPEN_DETAIL',
    CLOSE_DETAIL: 'DEALERS.CLOSE_DETAIL',
    OPEN_FILTER: 'DELAERS.OPEN_FILTER',
    OPEN_TOOLTIP: 'DELAERS.OPEN_TOOLTIP',
    CLOSE_FILTER: 'DEALERS.CLOSE_FILTER',
    RESET_ORIGIN: 'DEALERS.RESET_ORIGIN',
    SET_ORIGIN: 'DEALERS.SET_ORIGIN',
    CTA_CLICK: 'DEALERS.CTA_CLICK',
  },
  ERRORS: {
    GEOLOCATION: 'ERRORS.GEOLOCATION',
  },
  GEOLOCATION: {
    ALLOWED: 'GEOLOCATION.ALLOWED',
  },
  TABS: {
    SELECT: 'TABS.SELECT',
  },
  FILTERS: {
    SELECT: 'FILTERS.SELECT',
    UNSELECT: 'FILTERS.UNSELECT',
    OPEN_TOOLTIP: 'FILTERS.OPEN_TOOLTIP',
    APPLY: 'FILTERS.APPLY',
    RESET: 'FILTERS.RESET',
    SELECTED: 'FILTERS.SELECTED',
    UPDATE: 'FILTERS.UPDATE',
  },
  MAP: {
    RESIZE: 'MAP.RESIZE',
    READY: 'MAP.READY',
  },
};

module.exports = events;
